import { FORM_TYPES } from '../consts';
import { httpClient, normalizeError } from '../services/httpClient';
import { useAppStore } from '../store/appStore';
import { getFlowTypePayload } from './getFlowType';
import { getRequestHeaders } from './getRequestHeaders';

export const emailCheck = async (email: string, signal?: AbortSignal) => {
  try {
    const { formType } = useAppStore.getState();

    const response = await httpClient.post(
      '/lpapi/trial/EmailCheck',
      {
        email: email,
        sku: FORM_TYPES.BUSINESSTRIAL,
        flowType: getFlowTypePayload(formType),
      },
      {
        headers: getRequestHeaders(),
        validateStatus: () => true,
        signal,
      }
    );

    const isJsonBody = typeof response.data === 'object' && response.data !== null;
    return isJsonBody ? response.data : normalizeError(null);
  } catch (error) {
    return error;
  }
};
